module.exports = __webpack_public_path__ + "optiopay-logo.png?942f059a5f6e8365cf554fa43d7d590c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/optiopay-logo.png
// module id = 40
// module chunks = 0